import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetOffer } from "@models";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function BetOfferItemOfferResults(props: {
	offer: BetOffer;
}) {
	const myBetStore = useContext(MyBetsStoreContext);

	if (myBetStore == null) {
		return null;
	}

	if (props.offer.sportData.result == null || props.offer.isMulti) {
		return null;
	}
	const getLiveEvent =
		myBetStore.activeEventsStore.eventsMap.get(props.offer.eventId) || null;

	return (
		<div className="table--bets__result">
			<div className="table--bets__result__ft">
				{props.offer.formattedCurrentResult(getLiveEvent)}
			</div>

			{props.offer.scorePerPeriodString() != "" && (
				<div className="table--bets__result__ht">
					{props.offer.scorePerPeriodString(getLiveEvent)}
				</div>
			)}
		</div>
	);
});
